import { useState, useEffect, useRef } from "react";
import "./CateogoryFilterComponent.css";
import { printDebugLog } from "../../Utils/utils";

export default function CateogoryFilterComponent({
    listData = [],
    filtersDispatch,
    initialCateogoryFilter = [],
}) {
    const [inputValue, setInputValue] = useState("");
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [selectedItems, setSelectedItems] = useState(initialCateogoryFilter || []);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [showAllTags, setShowAllTags] = useState(false);
    const wrapperRef = useRef(null);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    const maxVisibleTags = 2;

    useEffect(() => {
        const results = listData.filter(
            (item) =>
                (item?.catgName?.toLowerCase().includes(inputValue.toLowerCase())
                    || item?.inventoryType?.toLowerCase().includes(inputValue.toLowerCase())
                    || item?.subCatgName?.toLowerCase().includes(inputValue.toLowerCase())
                ) &&
                !selectedItems.includes(item)
        );
        setFilteredOptions(results);
    }, [inputValue, listData, selectedItems]);

    // Click outside to close
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!wrapperRef.current.contains(e.target)) {
                setDropdownVisible(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (item) => {
        printDebugLog("handleSelect", item);
        if (!selectedItems.includes(item)) {
            const updated = [...selectedItems, item];
            setSelectedItems(updated);
            filtersDispatch({
                type: "setCategoryFilter",
                payload: item,
            });
        }
        setInputValue("");
        setDropdownVisible(false);
    };

    const handleRemove = (item) => {
        printDebugLog("handleRemove", item);
        const updated = selectedItems.filter((i) => i !== item);
        setSelectedItems(updated);
        filtersDispatch({
            type: "setRemoveCateogory",
            payload: item,
        });
    };

    const visibleTags = showAllTags
        ? selectedItems
        : selectedItems.slice(0, maxVisibleTags);
    const hiddenCount = selectedItems.length - maxVisibleTags;

    return (
        <div className="custom-autocomplete-wrapper" ref={wrapperRef}>
            <div className="tag-input-container" onClick={() => setDropdownVisible(true)}>
                {visibleTags.map((item, idx) => (
                    <span className="tag" key={idx}>
                        {`${item.catgName}(${item.inventoryType})`}
                        <button onClick={() => handleRemove(item)}>&times;</button>
                    </span>
                ))}
                {hiddenCount > 0 && (
                    <span className="more-tag" onClick={() => setShowAllTags((prev) => !prev)}>
                        {showAllTags ? "Show less" : `+${hiddenCount} more`}
                    </span>
                )}
                <input
                    type="text"
                    value={inputValue}
                    placeholder={"Search Cateogory"}
                    onChange={(e) => setInputValue(e.target.value)}
                    onFocus={() => setDropdownVisible(true)}
                    onKeyDown={(e) => {
                        if (!dropdownVisible || filteredOptions.length === 0) return;

                        if (e.key === "ArrowDown") {
                            e.preventDefault();
                            setHighlightedIndex((prev) => (prev + 1) % filteredOptions.length);
                        } else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            setHighlightedIndex((prev) =>
                                prev <= 0 ? filteredOptions.length - 1 : prev - 1
                            );
                        } else if (e.key === "Enter" && highlightedIndex >= 0) {
                            e.preventDefault();
                            handleSelect(filteredOptions[highlightedIndex]);
                        } else if (e.key === "Escape") {
                            setDropdownVisible(false);
                            setHighlightedIndex(-1);
                        }
                    }}
                />
            </div>

            {dropdownVisible && filteredOptions.length > 0 && (
                <ul className="dropdown">
                    {filteredOptions.map((item, idx) => (
                        <li
                            key={idx}
                            onMouseDown={() => handleSelect(item)}
                            className={idx === highlightedIndex ? "highlighted" : ""}
                        >
                            <div style={{
                                borderBottom: "1px solid #e0e0e0",
                                backgroundColor: idx % 2 === 0 ? "#e6f7ff" : "white",
                                background: "white",
                                cursor: "pointer",
                                color: "var(--dark-background-color)",
                                fontFamily: 'Source Sans Pro',
                            }}>
                                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: "16px" }}>{`${item.catgName}(${item.inventoryType})`}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
